import React, { Fragment, useState, useEffect } from "react";

// Material UI inputs
import { Grid, Breadcrumbs, Typography, TextField } from "@material-ui/core";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

//Custom Portal components
import FormModal from "../../FormModalComponents/FormModal";
import AgregarIcono from "../../../Icons/AgregarIcono";
import EditarIcono from "../../../Icons/EditarIcono";
import IntebotCatalog from "../../IntebotCatalog";

function AddTemplateButton(props) {
    let { addButton, editButton, isAddButton, currentButton, indexTable } = props;

    const errorHelperKeys = IntebotCatalog.errorHelper;

    const formErrorsInit = {
        formHasErrors: true,
        formResponseErrors: {
            text: true,
        },
        errorHelperForm: {
            text: errorHelperKeys.emptyField,
        },
    };

    const [button, setButton] = useState({ text: "" });
    const [formHasChanges, setFormHasChanges] = useState(false);
    const [formErrors, setFormErrors] = useState(formErrorsInit);
    const [previousValue, setPreviousValue] = useState({});
    const [isEditableDataSet, setIsEditableDataSet] = useState(false);

    useEffect(() => {
        if (isEditableDataSet) {
            searchFormErrors();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [button, isEditableDataSet]);

    const modalIsOpen = (isOpen) => {
        if (isOpen && !isAddButton) {
            setButton(currentButton);
            setPreviousValue(currentButton);
            setIsEditableDataSet(true);
        }
    };

    const saveButton = () => {
        isAddButton ? addButton(button) : editButton(button, indexTable);
        clearForm();
    };

    function handleChangesForm(targetName, targetValue) {
        let { formResponseErrors, errorHelperForm, formHasErrors } = formErrors;

        let buttonCopy = JSON.parse(JSON.stringify(button));
        let formResponseErrorsCopy = JSON.parse(JSON.stringify(formResponseErrors));
        let errorHelperFormCopy = JSON.parse(JSON.stringify(errorHelperForm));
        let formHasErrorsCopy = JSON.parse(JSON.stringify(formHasErrors));

        switch (targetName) {
            case "text":
                buttonCopy[targetName] = targetValue;
                if (targetValue === "") {
                    formResponseErrorsCopy[targetName] = true;
                    errorHelperFormCopy[targetName] = errorHelperKeys.emptyField;
                    formHasErrorsCopy = true;
                    break;
                }
                if (targetValue.length >= 20) {
                    formResponseErrorsCopy[targetName] = true;
                    errorHelperFormCopy[targetName] = errorHelperKeys.buttonMaxLength;
                    formHasErrorsCopy = true;
                    break;
                }
                //sin errores
                formResponseErrorsCopy[targetName] = false;
                errorHelperFormCopy[targetName] = errorHelperKeys.removeError;
                formHasErrorsCopy = false;
                break;
            default:
                break;
        }

        setButton(buttonCopy);
        setFormErrors({
            ...formErrors,
            formResponseErrors: formResponseErrorsCopy,
            errorHelperForm: errorHelperFormCopy,
            formHasErrors: formHasErrorsCopy,
        });
        setFormHasChanges(true);
    }

    const searchFormErrors = () => {
        let { formResponseErrors, errorHelperForm } = formErrors;

        let formResponseErrorsCopy = JSON.parse(JSON.stringify(formResponseErrors));
        let errorHelperFormCopy = JSON.parse(JSON.stringify(errorHelperForm));
        let formHasErrorsCopy = true;

        const value = button.text;
        if (value !== "" && value.length < 20) {
            errorHelperFormCopy["text"] = errorHelperKeys.removeError;
            formResponseErrorsCopy["text"] = false;
            formHasErrorsCopy = false;
        } else if (value.length >= 20) {
            errorHelperFormCopy["text"] = errorHelperKeys.buttonMaxLength;
            formResponseErrorsCopy["text"] = true;
            formHasErrorsCopy = true;
        }

        setFormErrors({
            ...formErrors,
            formResponseErrors: formResponseErrorsCopy,
            errorHelperForm: errorHelperFormCopy,
            formHasErrors: formHasErrorsCopy,
        });
        setIsEditableDataSet(true);
    };

    const clearForm = () => {
        setFormHasChanges(false);
        setFormErrors(formErrorsInit);
        setButton({ text: "" });
    };

    const undoChanges = () => {
        if (isAddButton) {
            clearForm();
            return;
        }
        setButton(previousValue);
        setFormHasChanges(false);
        setIsEditableDataSet(true);
    };

    return (
        <Fragment>
            <FormModal
                modalTitle={
                    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
                        <Typography color="textPrimary">
                            {isAddButton ? "Agregar botón" : "Editar botón"}
                        </Typography>
                    </Breadcrumbs>
                }
                buttonType={isAddButton ? "link" : null}
                buttonTooltip={isAddButton ? "Abrir modal para agregar botón" : "Editar botón"}
                justIcon={isAddButton ? null : <EditarIcono width="20px" height="20px" />}
                buttonName={isAddButton ? "Agregar botón" : null}
                startIcon={isAddButton ? <AgregarIcono width="15px" height="15px" /> : null}
                alignButtonRight={isAddButton ? true : null}
                isOpen={(e) => (e ? modalIsOpen(e) : null)}
                onCancel={() => undoChanges()}
                onSave={() => saveButton()}
                disableSaveOnError={true}
                hasChanges={formHasChanges}
                hasErrors={formErrors.formHasErrors}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <label className="top-label-field">
                            <span style={{ color: "red" }}>* </span>
                            Texto del botón
                        </label>
                        <TextField
                            name={"text"}
                            value={button.text}
                            fullWidth
                            variant="outlined"
                            size="small"
                            onChange={(e) => {
                                handleChangesForm(e.target.name, e.target.value);
                            }}
                            error={formErrors.formResponseErrors.text}
                            helperText={formErrors.errorHelperForm.text}
                        ></TextField>
                    </Grid>
                </Grid>
            </FormModal>
        </Fragment>
    );
}

export default AddTemplateButton;
